module.exports = __webpack_public_path__ + "img/r.00c27b61.jpg";